module.exports = __webpack_public_path__ + "static/paneles_de_control_principal-a6f641583c5efa29cc72a20582cb6819.png";